import AppleMusic from "./AppleMusic.svg?react";
import Apple from "./Apple_100_Default.svg?react";
import Check_100 from "./Check_100_Default.svg?react";
import Close_100 from "./Close_100_Default.svg?react";
import Close_100_small from "./Close_100_Small.svg?react";
import Close_700 from "./Close_700_Default.svg?react";
import Default_700 from "./Default_700_Default.svg?react";
import DownArrow_100 from "./DownArrow_100_Default.svg?react";
import Edit_100 from "./Edit_100_Default.svg?react";
import Email_100 from "./Email_100_Default.svg?react";
import Google from "./Google_100_Default.svg?react";
import Information_100 from "./Information_100.svg?react";
import Instagram from "./Instagram_100_Default.svg?react";
import Kakaotalk from "./KakaoTalk_100_Default.svg?react";
import Kakao from "./Kakao_100_Default.svg?react";
import LeftArrow_100 from "./LeftArrow_100_Default.svg?react";
import LeftArrow_700 from "./LeftArrow_700_Default.svg?react";
import Lock from "./Lock.svg?react";
import Menu_700 from "./Menu_700_Default.svg?react";
import Minus_100 from "./Minus_100_Default.svg?react";
import More_100 from "./More_100_Default.svg?react";
import Naver from "./Naver_100_Default.svg?react";
import Pay_100 from "./Pay_100.svg?react";
import Person_700 from "./Person_700_Default.svg?react";
import Plus_100 from "./Plus_100_Default.svg?react";
import Plus_100_small from "./Plus_100_Default_3.svg?react";
import Plus_700 from "./Plus_700_Default.svg?react";
import Qm_100 from "./Qm_100_Default.svg?react";
import Return_100 from "./Return_100_Default.svg?react";
import RightArrow_100 from "./RightArrow_100_Default.svg?react";
import Search_100 from "./Search_100_Default.svg?react";
import Search_700 from "./Search_700_Default.svg?react";
import Share_700 from "./Share_700_Default.svg?react";
import ShoppingBag_700 from "./ShoppingBag_700_Default.svg?react";
import Sort_100 from "./Sort_100_Default.svg?react";
import Spotify from "./Spotify_100_Default.svg?react";
import Star_700 from "./Star_700_Default.svg?react";
import Toast_error from "./Toast_error.svg?react";
import Toast_info from "./Toast_info.svg?react";
import Toast_success from "./Toast_success.svg?react";
import Toast_warning from "./Toast_warning.svg?react";
import Trash_100 from "./Trash_100_Default.svg?react";
import Youtube from "./Youtube_100_Default.svg?react";
import Line_short from "./check_2.svg?react";
import Discount_700 from "./discount_700_Default.svg?react";
import Discount_grey from "./discount_grey.svg?react";
import Line_long from "./drawing.svg?react";
import A_SVG from "./letters-01.svg";
import B_SVG from "./letters-02.svg";
import C_SVG from "./letters-03.svg";
import D_SVG from "./letters-04.svg";
import E_SVG from "./letters-05.svg";
import F_SVG from "./letters-06.svg";
import G_SVG from "./letters-07.svg";
import H_SVG from "./letters-08.svg";
import I_SVG from "./letters-09.svg";
import J_SVG from "./letters-10.svg";
import K_SVG from "./letters-11.svg";
import L_SVG from "./letters-12.svg";
import M_SVG from "./letters-13.svg";
import N_SVG from "./letters-14.svg";
import O_SVG from "./letters-15.svg";
import P_SVG from "./letters-16.svg";
import Q_SVG from "./letters-17.svg";
import R_SVG from "./letters-18.svg";
import S_SVG from "./letters-19.svg";
import T_SVG from "./letters-20.svg";
import U_SVG from "./letters-21.svg";
import V_SVG from "./letters-22.svg";
import W_SVG from "./letters-23.svg";
import X_SVG from "./letters-24.svg";
import Y_SVG from "./letters-25.svg";
import Z_SVG from "./letters-26.svg";
import One_SVG from "./letters-27.svg";
import Two_SVG from "./letters-28.svg";
import Three_SVG from "./letters-29.svg";
import Four_SVG from "./letters-30.svg";
import Five_SVG from "./letters-31.svg";
import Siz_SVG from "./letters-32.svg";
import Seven_SVG from "./letters-33.svg";
import Eight_SVG from "./letters-34.svg";
import Nine_SVG from "./letters-35.svg";
import Zero_SVG from "./letters-36.svg";
import Exclamation_SVG from "./letters-37.svg";
import Question_SVG from "./letters-38.svg";
import At_SVG from "./letters-39.svg";
import Sharp_SVG from "./letters-40.svg";
import Dollar_SVG from "./letters-41.svg";
import Percent_SVG from "./letters-42.svg";
import And_SVG from "./letters-43.svg";
import LeftParenthesis_SVG from "./letters-44.svg";
import RightParenthesis_SVG from "./letters-45.svg";
import Hyphen_SVG from "./letters-46.svg";
import Equal_SVG from "./letters-47.svg";
import Plus_SVG from "./letters-48.svg";
import LeftBracket_SVG from "./letters-49.svg";
import RightBracket_SVG from "./letters-50.svg";
import LeftBrace_SVG from "./letters-51.svg";
import RightBrace_SVG from "./letters-52.svg";
import LeftAngle_SVG from "./letters-53.svg";
import RightAngle_SVG from "./letters-54.svg";
import Loading from "./loading.svg?react";
import Spinner from "./loading_spinner.svg?react";
import Picture from "./picture.svg?react";

export {
  Apple,
  AppleMusic,
  Check_100,
  Close_100,
  Close_100_small,
  Close_700,
  Default_700,
  Discount_700,
  Discount_grey,
  DownArrow_100,
  Edit_100,
  Google,
  Instagram,
  Kakao,
  Kakaotalk,
  LeftArrow_100,
  LeftArrow_700,
  Line_long,
  Line_short,
  Menu_700,
  Minus_100,
  More_100,
  Naver,
  Person_700,
  Plus_100,
  Plus_100_small,
  Plus_700,
  Pay_100,
  Qm_100,
  Information_100,
  Return_100,
  RightArrow_100,
  Search_100,
  Search_700,
  Share_700,
  ShoppingBag_700,
  Sort_100,
  Spotify,
  Star_700,
  Toast_error,
  Toast_info,
  Toast_success,
  Toast_warning,
  Trash_100,
  Youtube,
  Email_100,
  Loading,
  Spinner,
  Lock,
  Picture,
};

// T, U, N, E 는 필수
export const baseList = [
  { fileUrl: T_SVG, name: "T", alt: "T" },
  { fileUrl: U_SVG, name: "U", alt: "U" },
  { fileUrl: N_SVG, name: "N", alt: "N" },
  { fileUrl: E_SVG, name: "E", alt: "E" },
];

export const imageList = [
  { fileUrl: A_SVG, name: "A", alt: "A" },
  { fileUrl: B_SVG, name: "B", alt: "B" },
  { fileUrl: C_SVG, name: "C", alt: "C" },
  { fileUrl: D_SVG, name: "D", alt: "D" },
  // { fileUrl: E_SVG, name: "E" },
  { fileUrl: F_SVG, name: "F", alt: "F" },
  { fileUrl: G_SVG, name: "G", alt: "G" },
  { fileUrl: H_SVG, name: "H", alt: "H" },
  { fileUrl: I_SVG, name: "I", alt: "I" },
  { fileUrl: J_SVG, name: "J", alt: "J" },
  { fileUrl: K_SVG, name: "K", alt: "K" },
  { fileUrl: L_SVG, name: "L", alt: "L" },
  { fileUrl: M_SVG, name: "M", alt: "M" },
  // { fileUrl: N_SVG, name: "N" },
  { fileUrl: O_SVG, name: "O", alt: "O" },
  { fileUrl: P_SVG, name: "P", alt: "P" },
  { fileUrl: Q_SVG, name: "Q", alt: "Q" },
  { fileUrl: R_SVG, name: "R", alt: "R" },
  { fileUrl: S_SVG, name: "S", alt: "S" },
  // { fileUrl: T_SVG, name: "T" },
  // { fileUrl: U_SVG, name: "U" },
  { fileUrl: V_SVG, name: "V", alt: "V" },
  { fileUrl: W_SVG, name: "W", alt: "W" },
  { fileUrl: X_SVG, name: "X", alt: "X" },
  { fileUrl: Y_SVG, name: "Y", alt: "Y" },
  { fileUrl: Z_SVG, name: "Z", alt: "Z" },
  { fileUrl: One_SVG, name: "One", alt: "1" },
  { fileUrl: Two_SVG, name: "Two", alt: "2" },
  { fileUrl: Three_SVG, name: "Three", alt: "3" },
  { fileUrl: Four_SVG, name: "Four", alt: "4" },
  { fileUrl: Five_SVG, name: "Five", alt: "5" },
  { fileUrl: Siz_SVG, name: "Six", alt: "6" },
  { fileUrl: Seven_SVG, name: "Seven", alt: "7" },
  { fileUrl: Eight_SVG, name: "Eight", alt: "8" },
  { fileUrl: Nine_SVG, name: "Nine", alt: "9" },
  { fileUrl: Zero_SVG, name: "Zero", alt: "10" },
  { fileUrl: Exclamation_SVG, name: "Exclamation", alt: "!" },
  { fileUrl: Question_SVG, name: "Question", alt: "?" },
  { fileUrl: At_SVG, name: "At", alt: "@" },
  { fileUrl: Sharp_SVG, name: "Sharp", alt: "#" },
  { fileUrl: Dollar_SVG, name: "Dollar", alt: "$" },
  { fileUrl: Percent_SVG, name: "Percent", alt: "%" },
  { fileUrl: And_SVG, name: "And", alt: "&" },
  { fileUrl: LeftParenthesis_SVG, name: "LeftParenthesis", alt: "(" },
  { fileUrl: RightParenthesis_SVG, name: "RightParenthesis", alt: ")" },
  { fileUrl: Hyphen_SVG, name: "Hyphen", alt: "-" },
  { fileUrl: Equal_SVG, name: "Equal", alt: "=" },
  { fileUrl: Plus_SVG, name: "Plus", alt: "+" },
  { fileUrl: LeftBracket_SVG, name: "LeftBracket", alt: "[" },
  { fileUrl: RightBracket_SVG, name: "RightBracket", alt: "]" },
  { fileUrl: LeftBrace_SVG, name: "LeftBrace", alt: "{" },
  { fileUrl: RightBrace_SVG, name: "RightBrace", alt: "}" },
  { fileUrl: LeftAngle_SVG, name: "LeftAngle", alt: "<" },
  { fileUrl: RightAngle_SVG, name: "RightAngle", alt: ">" },
];
